import { useMemo } from 'react';

import { useKeywordMetadata } from '@kc-console/context';
import { StatusServiceKeyword } from '@kc-console/guard';

import type { UseQueryOptions } from '@tanstack/react-query';
import type { Region, ServiceMeta } from '@kc-console/context';

export type UseServiceMenuOptions = UseQueryOptions<ServiceMeta>;

const useServiceMenu = (region?: Region, options?: UseServiceMenuOptions) => {
  const { data: keywordMetadata } = useKeywordMetadata(StatusServiceKeyword, region, options);

  const { name = '', badges = [], keyword = '' } = keywordMetadata || {};
  const menus = useMemo(() => keywordMetadata?.menus ?? [], [keywordMetadata?.menus]);
  const targetLnbBadges = useMemo(() => (badges.length > 0 ? [badges[0]] : []), [badges]);

  return { name, badges, targetLnbBadges, keyword, menus };
};

export default useServiceMenu;
